<template>
  <div>
    <v-text-field
      :class="errorClass"
      :counter="counter"
      :error-messages="errorMessages"
      :hint="hint"
      :label="label"
      :name="name"
      :min="min"
      :mmax="max"
      :step="step"
      :prepend-icon="prepend"
      :prepend-icon-cb="prependCb"
      v-model="_value"
      type="number"
    ></v-text-field>
    <has-error :form="form" :field="name"></has-error>
  </div>
</template>

<script>
import TextInput from './TextInput'

export default {
  extends: TextInput,
  name: 'number-input',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    hint: {
      type: String
    },
    vErrors: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    prepend: {
      type: String,
      default: ''
    },
    min: {
      type: [Number],
      default: -999999
    },
    max: {
      type: [Number],
      default: 9999999999
    },
    step: {
      type: [Number],
      default: 1
    },
    counter: {
      type: [Boolean, Number, String],
      default: false
    },
    value: {
      type: [String, Number]
    },
    prependCb: {
      type: Function,
      default: null
    },
    autofocus: {
      type: [Boolean],
      default: false
    },
    autocomplete: {
      type: [Boolean, String, Number],
      default: false,
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/NumberInput.vue